import request from '@/services/interceptor.js'

/* GESTIONE CLIENTE */
export const get_listaClienti = (data) => {
    return request({
        url: 'clienti',
        method: 'post',
        data: data,
        noLoadingBar: true
    })
};

export const delete_cliente = (data) => {
    return request({
        url: 'clienti/elimina/cliente',
        method: 'post',
        data: data,
        loadingBar: true,
    })
};


export const get_certificazioni = () => {
    return request({
        url: 'clienti/certificazioni',
        method: 'get',
    })
};



export const get_clientiExcel = (par) => {
    return request({
      url: 'clienti/excel',
      method: 'post',
      data: par,
      loadingBar: true
    })
  }



/* ARCHIVIO */
export const carica_file_filtri = (data, par) => {
    return request({
        url: '/Documenti/carica' + par,
        method: 'post',
        data: data,
    })
}

export const get_file = (data) => {
    return request({
        url: '/Documenti/elenco',
        method: 'post',
        data: data,
    })

}
//Elimina File nella directory dell'utente
export const elimina_file = (data, par) => {
    return request({
        url: '/Documenti/elimina' + par,
        method: 'post',
        data: data,
    })
}
//sacrica file
export const download_file = (par) => {
    return request({
        url: 'Documenti/download/files' + par,
        method: 'get',
        responseType: 'blob'
    })
};


//Creare una cartella
export const crea_cartella = (data, par) => {
    return request({
        url: '/Documenti/crea/cartella' + par,
        method: 'post',
        data: data,
    })
}

export const getFileCliente = (data) => {
    return request({
        url: '/Documenti/risorse/cliente',
        method: 'post',
        data: data,
    })
}

export const elimina_cartella = (par) => {//data
    return request({
        url: '/Documenti/elimina/cartella' + par,
        method: 'get',//post
        //data: data,
    })
}

export const rinomina_cartella = (data, par) => {
    return request({
        url: '/Documenti/rinomina/cartella' + par,
        method: 'post',
        data: data,
    })
}

// Solo le sottocartelle di un percorso (selettore destinazione per lo spostamento)
export const get_sole_cartelle = (par) => {
    return request({
        url: '/Documenti/cartelle' + par,
        method: 'get',
    })
}

// Sposta file/cartella (solo admin)
export const sposta_elemento = (data) => {
    return request({
        url: '/Documenti/sposta',
        method: 'post',
        data: data,
    })
}



/* OPERAZIONI */
export const getOperazioni = (data) => {
    return request({
        url: '/Operazioni',
        method: 'post',
        data: data,
    })
}



/* GESTIONE COMUNICAZIONI */
export const get_gestioneComunicazioni = () => {
    return request({
        url: 'comunicazioni/gestione/comunicazioni',
        method: 'get',
        loadingBar: true
    })
};

export const get_listaClientiComuicazioni = (data) => {
    return request({
        url: 'clienti/clienti',
        method: 'post',
        data: data,
        noLoadingBar: true
    })
};
